<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'PROFIL_UTILISATEUR.TITLE_DOCUMENT' | translate }}
    <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">folder</mat-icon>
  </p>
  <router-outlet></router-outlet>
 